import { basicConfig, terminalAbnormal } from "@api"
export default {
  state: {
    // 全局加载
    spinning: true,
    //服务端基础配置
    basicConfig: {},
    //终端异常状态
    terminalAbnormal: {
      station: [],
      device: []
    },
    isAndroid: isAndroid()
  },
  mutations: {
    
  },
  actions:{
    // 加载状态
    showSpinning({state}){
      state.spinning = true
    },
    // 取消加载状态
    hideSpinning({state}){
      state.spinning = false
    },
    // 刷新服务端基础配置项
    async refreshBasicConfig({state}){
      const {data} = await basicConfig()
      state.basicConfig = data
    },
    // 刷新终端异常状态
    async refreshTerminalAbnormal({state}){
      const {data} = await terminalAbnormal()
      state.terminalAbnormal = data
    }
  },
  getters:{
    /**
     * 获取布局模式
     * 1：基础布局
     * 2：个别按钮下置 
     */
    getLayoutMode(){
      let layoutMode = localStorage.getItem("layout")
      if(layoutMode) {
        return `layout-${layoutMode}`
      }
      //其他情况不做处理
      return '';
    },
    // 获取服务器地址
    getConfigServerUrl(state){
      let port = state.basicConfig.port
      port = port ? `:${port}` : port
      return `http://${state.basicConfig.ip + port}`
    },
    // 获取第一个工位异常记录
    getFirstStationAbnorml(state){
      return state.terminalAbnormal.station[0] || {}
    },
    // 获取第一个设备异常记录
    getFirstDeviceAbnorml(state){
      return state.terminalAbnormal.device[0] || {}
    }
  },
}

/**
 * 判断是否为安卓容器
 * @returns 
 */
function isAndroid(){
  var u = navigator.userAgent;
  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
}